export const HazmatOptions = {
  AceptedItems: 'AceptedItems',
  NotAceptedItems: 'NotAceptedItems',
  DontSellHazmatItems: 'DontSellHazmatItems'
}
